
"use client";
import Image from "next/image";

interface LogoOnlyProps {
  width?: number;
  height?: number;
  className?: string;
  priority?: boolean;
}

export default function LogoOnlyImage({ 
  width = 24, 
  height = 24,
  className = "",
  priority = false 
}: LogoOnlyProps) {
  return (
    <Image
      className={className}
      src="/zundoku.svg"
      alt="Zundoku Logo"
      width={width}
      height={height}
      priority={priority}
    />
  );
}